import React, { useEffect, useMemo, useState } from "react";
import FlipNumbers from "react-flip-numbers";

const pad2 = (n) => String(n).padStart(2, "0");

export default function LiveFlipClock({
  height = 48,
  width = 34,
  fontSize = 36,
}) {
  const [now, setNow] = useState(new Date());

  // tick every second
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const hh = useMemo(() => {
    const h = now.getHours();
    const hr = ((h + 11) % 12) + 1;
    return pad2(hr);
  }, [now]);
  const mm = pad2(now.getMinutes());
  const ss = pad2(now.getSeconds());
  const ampm = now.getHours() >= 12 ? "PM" : "AM";

  const labelStyle = {
    color: "#fff",
    fontSize: 12,
    textAlign: "center",
    marginTop: 6,
    letterSpacing: 0.4,
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        background: "#111",
        borderRadius: 12,
        padding: "10px 12px",
        boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
      }}
    >
      {/* HOURS */}
      <div style={{ textAlign: "center" }}>
        <FlipNumbers
          height={height}
          width={width}
          color="#fff"
          background="#222"
          play
          perspective={900}
          numbers={hh}
          numberStyle={{ fontSize }}
        />
        <div style={labelStyle}>Hours</div>
      </div>

      <div style={{ color: "#666", fontWeight: 700, fontSize: 28 }}>:</div>

      {/* MINUTES */}
      <div style={{ textAlign: "center" }}>
        <FlipNumbers
          height={height}
          width={width}
          color="#fff"
          background="#222"
          play
          perspective={900}
          numbers={mm}
          numberStyle={{ fontSize }}
        />
        <div style={labelStyle}>Minutes</div>
      </div>

      <div style={{ color: "#666", fontWeight: 700, fontSize: 28 }}>:</div>

      {/* SECONDS */}
      <div style={{ textAlign: "center" }}>
        <FlipNumbers
          height={height}
          width={width}
          color="#fff"
          background="#222"
          play
          perspective={900}
          numbers={ss}
          numberStyle={{ fontSize }}
        />
        <div style={labelStyle}>Seconds</div>
      </div>

      {/* AM/PM */}
      <div
        style={{
          marginLeft: 8,
          padding: "6px 10px",
          background: "#111",
          color: "#fff",
          borderLeft: "1px solid #222",
          fontWeight: 700,
          borderRadius: 6,
          fontSize: 12,
        }}
      >
        {ampm}
      </div>
    </div>
  );
}
